import React, { useContext, useState } from 'react';
import SectionBlock from './SectionBlock';
import { IconInfoM, IconPersonSafetyL } from '../../../icons';
import { MatchingDialogContext } from '../configs';
import { showSection } from '../utils';
import {
    horseQualifications,
    HORSE_QUALIFICATION_BASIC_TRAINING,
    HORSE_QUALIFICATION_ABSENT,
} from '../../../marketplace-custom-config';
import { mapUserCountryByCountryCode } from '../../../util/location';
import css from './sections.css';
import QualificationModal from '../../QualificationModal/QualificationModal';

const SectionQualification = () => {
    const {
        scoreData,
        categorySelected,
        currentPageListing,
        horseListing,
        riderListing,
        horseImage,
        riderProfileImage,
    } = useContext(MatchingDialogContext);
    const [qualificationKey, setQualificationKey] = useState(null);

    const qualificationScoreNum = scoreData?.qualificationScore || 0;
    const qualificationScore = { total: qualificationScoreNum, maxScore: 100 };

    const { shouldBeShown } = showSection({
        categorySelected,
        ...qualificationScore,
    });

    if (!shouldBeShown) return null;

    const riderListingPublicData = riderListing?.attributes?.publicData || {};
    const horseListingPublicData = horseListing?.attributes?.publicData || {};

    const { riderCertification, userCountry: riderCountryCode } = riderListingPublicData;
    const { requiredQualificationLevel } = horseListingPublicData;

    const countryCode = mapUserCountryByCountryCode(riderCountryCode);

    if (!requiredQualificationLevel || requiredQualificationLevel === 'keine') return null;

    const isNoMatch =
        !riderCertification ||
        typeof riderCertification !== 'object' ||
        Object.values(riderCertification).length === 0;

    let entriesDictionary = [
        {
            matches: false,
            images: [horseImage],
            entryKey: horseQualifications[requiredQualificationLevel]?.label,
            horseQualificationKey: requiredQualificationLevel,
        },
        {
            matches: false,
            images: [riderProfileImage],
            entryKey: Object.values(horseQualifications).find(
                ({ key }) => key !== requiredQualificationLevel
            )?.label,
            horseQualificationKey: requiredQualificationLevel,
        },
    ];

    if (isNoMatch) {
        entriesDictionary = [
            {
                matches: false,
                images: [horseImage],
                entryKey: horseQualifications[requiredQualificationLevel].label,
                horseQualificationKey: requiredQualificationLevel,
            },
        ];
    }

    const riderQualificationsValues = Object.values(riderCertification || {}).flatMap(s => s);

    const includedDisciplinesByCountry =
        horseQualifications[requiredQualificationLevel].includedDisciplines[countryCode];
    /**
     * {
     *  [BREVET]: BREVET,
     *  [COMBINED_LICENSE]: COMBINED_LICENSE
     * }
     */
    const requiredQualificationLevelDictionary = Object.values(includedDisciplinesByCountry || {})
        .flatMap(s => s)
        .reduce(
            (acc, discipline) => ({
                ...acc,
                [discipline]: discipline,
            }),
            {}
        );

    const is1To1Match = riderQualificationsValues.some(
        riderQualification => requiredQualificationLevelDictionary[riderQualification]
    );

    if (is1To1Match) {
        entriesDictionary = [
            {
                matches: true,
                images: [riderProfileImage, horseImage],
                entryKey: horseQualifications[requiredQualificationLevel].label,
            },
        ];
    }

    return (
        <>
            <SectionBlock scoreData={scoreData}>
                <SectionBlock.Header>
                    <IconPersonSafetyL />
                    <span>Qualifikationen</span>
                </SectionBlock.Header>
                <SectionBlock.ScoreBadge sectionScoreData={qualificationScore} />
                <section>
                    {entriesDictionary
                        .filter(
                            ({ entryKey }) => entryKey?.toLowerCase() !== HORSE_QUALIFICATION_ABSENT
                        )
                        .map(({ entryKey, matches, images, horseQualificationKey }, index, arr) => (
                            <>
                                <SectionBlock.ScoreLine
                                    key={`discipline-${index}`}
                                    matches={matches}
                                    lineLabel={entryKey}
                                    avatars={images.map((image, index) => (
                                        <SectionBlock.ScoreLineAvatar
                                            key={`discipline-image-${index}`}
                                            avatarUrl={image}
                                        />
                                    ))}
                                >
                                    <IconInfoM
                                        className={css.infoBadge}
                                        onClick={() =>
                                            setQualificationKey(
                                                horseQualificationKey ||
                                                    HORSE_QUALIFICATION_BASIC_TRAINING
                                            )
                                        }
                                    />
                                </SectionBlock.ScoreLine>
                                {index < arr.length - 1 && <SectionBlock.Delimiter />}
                            </>
                        ))}
                </section>
            </SectionBlock>
            {qualificationKey && (
                <QualificationModal
                    isOpen
                    onClose={() => setQualificationKey(null)}
                    currentListing={currentPageListing}
                    initialQualification={qualificationKey}
                />
            )}
        </>
    );
};

export default SectionQualification;
